import { GetAgencyType, EditAgencyType,InsertAgencyType, DELETEAgencyType } from "../type";
import {  InsertData } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateAgencyTypeAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/AgencyType`, data);
    dispatch({
      type: InsertAgencyType,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: InsertAgencyType,
      payload: "Error" + e,
    });
  }
};
export const UpdateAgencyTypeAction = (data) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/AgencyType`, data);
    dispatch({
      type: EditAgencyType,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: EditAgencyType,
      payload: "Error" + e,
    });
  }
};
export const DeleteAgencyTypeAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/AgencyType?id=${id}`);
    dispatch({
      type: DELETEAgencyType,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETEAgencyType,
      payload: "Error" + e,
    });
  }
};
export const GetAllAgencyTypeAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/AgencyType`);
    dispatch({
      type: GetAgencyType,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GetAgencyType,
      payload: "Error" + e,
    });
  }
};